import React, { useState, useEffect } from 'react';
import { getKdramaGenres } from './API';
import { FormControl, Select, MenuItem, Box, Button, Checkbox, ListItemText, OutlinedInput } from '@mui/material';

const keywordOptions = [
    { label: 'Romance', id: 9840 },
    { label: 'Vengeance', id: 9748 },
    { label: 'Anti-héros', id: 285809 },
    { label: 'Chaebol', id: 318482 },
    { label: 'Comédie romantique', id: 9799 },
    { label: 'Tranche de vie', id: 9914 },
    { label: 'Corruption', id: 417 },
];

function FilterBar({ onFilterChange }) {
    const [kdramaGenres, setKdramaGenres] = useState([]);
    const [filters, setFilters] = useState({
        rating: '',
        genre: '18',
        keywords: [],
    });

    useEffect(() => {
        const fetchGenres = async () => {
            try {
                const data = await getKdramaGenres();
                setKdramaGenres(data.genres);
            } catch (error) {
                console.error('Erreur lors de la recherche de genre pour les K-dramas:', error);
            }
        };
        fetchGenres();
    }, []);

    const handleKeywordChange = (event) => {
        const { target: { value } } = event;
        setFilters((prevFilters) => ({
            ...prevFilters,
            keywords: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const appliedFilters = {
            ...filters,
            keywords: filters.keywords.map((keywordId) => keywordId).join(','),
        };
        onFilterChange(appliedFilters);
    };

    const handleReset = () => {
        const defaultFilters = {
            rating: '',
            genre: '18',
            keywords: [],
        };
        setFilters(defaultFilters);
        onFilterChange(defaultFilters);
        localStorage.removeItem('filters');
        localStorage.removeItem('currentPage');
        localStorage.removeItem('scrollPosition');
        window.location.reload();
    };

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
                <FormControl sx={{ backgroundColor: '#f9f9f9', minWidth: 150 }}>
                    <Select
                        displayEmpty
                        id="rating"
                        name="rating"
                        value={filters.rating}
                        onChange={handleChange}
                        inputProps={{
                            'aria-label': 'Note',
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .MuiSelect-select': {
                                padding: '12px 10px',
                            },
                        }}
                        renderValue={(value) => (value ? value : <span style={{ color: '#aaa' }}>Note</span>)}
                    >
                        <MenuItem value="high-to-low">De la plus haute à la plus basse</MenuItem>
                        <MenuItem value="low-to-high">De la plus basse à la plus haute</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ backgroundColor: '#f9f9f9', minWidth: 150 }}>
                    <Select
                        displayEmpty
                        id="genre"
                        name="genre"
                        value={filters.genre}
                        onChange={handleChange}
                        inputProps={{
                            'aria-label': 'Genre',
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .MuiSelect-select': {
                                padding: '12px 10px',
                            },
                        }}
                        renderValue={(value) =>
                            value ? kdramaGenres.find((g) => g.id === parseInt(value))?.name : <span style={{ color: '#aaa' }}>Genre</span>
                        }
                    >
                        {kdramaGenres.map((genre) => (
                            <MenuItem key={genre.id} value={genre.id}>
                                {genre.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl sx={{ backgroundColor: '#f9f9f9', minWidth: 150 }}>
                    <Select
                        multiple
                        displayEmpty
                        value={filters.keywords}
                        onChange={handleKeywordChange}
                        input={<OutlinedInput />}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .MuiSelect-select': {
                                padding: '12px 10px',
                            },
                        }}
                        renderValue={(selected) =>
                            selected.length === 0 ? (
                                <span style={{ color: '#aaa' }}>Mots-clés</span>
                            ) : (
                                selected.map((id) => keywordOptions.find((option) => option.id === id)?.label).join(', ')
                            )
                        }
                    >
                        {keywordOptions.map((keyword) => (
                            <MenuItem key={keyword.id} value={keyword.id}>
                                <Checkbox checked={filters.keywords.indexOf(keyword.id) > -1} />
                                <ListItemText primary={keyword.label} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button type="submit" variant="contained" sx={{ backgroundColor: '#2596BE', '&:hover': { backgroundColor: '#1976d2' }, }}>
                    Filtrer
                </Button>
                <Button type="button" variant="outlined" onClick={handleReset} sx={{ marginLeft: '1rem' }}>
                    Réinitialiser
                </Button>
            </Box>
        </form>
    );
}

export default FilterBar;
